import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fullRouteNavItems } from '../../constants/navbar.constants';
import { FullRouteNavItem } from '../../models/nav-item.model';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit, AfterViewInit {
  currentModule?: string;
  isMobile = true;
  navItems: FullRouteNavItem[] = [];

  constructor(
    private observer: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.navItems = fullRouteNavItems;
    this.cdr.detectChanges();

    this.observer.observe(['(max-width: 800px)']).subscribe(screenSize => {
      if (screenSize.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
  }

  ngAfterViewInit() {
    this.router.events.subscribe(() => {
      this.currentModule = this.router.url.split('/')[1];
    });
  }
}
